import { render } from "./LayoutHerder.vue?vue&type=template&id=6accb701"
import script from "./LayoutHerder.vue?vue&type=script&lang=js"
export * from "./LayoutHerder.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__